import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { RuleContainer } from "@models/configurators/rule-container";
import { IConfiguratorFunction } from "@models/entity-models";
import { eRuleType } from "@models/enums";

@Kbo(CToken.ConfiguratorFunction)
export class ConfiguratorFunction extends RuleContainer implements IConfiguratorFunction {
    constructor(kom: KbObjectManager) {
        super(kom);

        this.ruleType = eRuleType.function;
    }   
}
